'use es6';

export const DELETE = 'DELETE';
export const GET = 'GET';
export const PATCH = 'PATCH';
export const POST = 'POST';
export const PUT = 'PUT';